export const TIMESHEET_SECTION_NAME = 'timesheet';
export const WEEK_DETAILS_SCREEN_NAME = 'week_details_page';
export const WEEKS_OVERVIEW_SCREEN_NAME = 'weeks_overview_page';
export const SHIFT_OVERVIEW_SCREEN_NAME = 'overview_page';
export const HOMEPAGE_SCREEN_NAME = 'home_page';
export const ADD_SHIFT_MODAL_SCREEN_NAME = 'add_shift_modal';
export const UNAUTHORIZED_WELCOME_SECTION_NAME = 'unauthorized_welcome';

export enum TrackingEvents {
  // add shift actions
  CONFIRM_SHIFT = 'CONFIRM_SHIFT',
  INIT_SHIFT = 'INIT_SHIFT',
  ABORT_SHIFT = 'ABORT_SHIFT',
  // page viewed
  HOME_PAGE_VIEWED = 'HOME_PAGE_VIEWED',
  OVERVIEW_PAGE_VIEWED = 'OVERVIEW_PAGE_VIEWED',
  WEEK_DETAILS_PAGE_VIEWED = 'WEEK_DETAILS_PAGE_VIEWED',
  WEEKS_OVERVIEW_PAGE_VIEWED = 'WEEKS_OVERVIEW_PAGE_VIEWED',
  // element clicked
  WEEK_BUTTON_CLICKED = 'WEEK_BUTTON_CLICKED',
  ADD_BREAK_BUTTON_CLICKED = 'ADD_BREAK_BUTTON_CLICKED',
  REMOVE_BREAK_BUTTON_CLICKED = 'REMOVE_BREAK_BUTTON_CLICKED',
  ADD_COMMENT_BUTTON_CLICKED = 'ADD_COMMENT_BUTTON_CLICKED',
  REMOVE_COMMENT_BUTTON_CLICKED = 'REMOVE_COMMENT_BUTTON_CLICKED',
  CONTINUE_BUTTON_CLICKED = 'CONTINUE_BUTTON_CLICKED',
  INIT_LOGIN = 'INIT_LOGIN'
}

export enum LoginType {
  PASSWORDLESS_EMAIL = 'passwordless_email',
  CREDENTIALS = 'credentials'
}
